import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { AdditionalInfo, ConfigurationApi, ImmigrationActivity, LookupApi, LookupField } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { LoaderService } from 'src/app/core/loader.service';
import { LookupTypeKeys } from 'src/app/shared/lookup-type-keys';
import { nullSafe } from 'src/app/utils';

@Component({
  selector: 'eos-imm-task-amendment-edit',
  templateUrl: './imm-task-amendment-edit.component.html',
  styleUrls: ['./imm-task-amendment-edit.component.css']
})
export class ImmTaskAmendmentEditComponent implements OnInit {

  activity: ImmigrationActivity;
  visaCountry: string;
  visaType: string;
  countries: LookupField[] = [];
  visaTypes: LookupField[];
  visas: LookupField[] = [];
  preboardingTypes: LookupField[];
  officeToBeVisited: LookupField[] = [];
  currentVisaStatus: LookupField[];
  nationality: LookupField[];
  typeOfSupport: LookupField[];
  officeLE: LookupField[] = [];
  excludedNationality: LookupField[];
  employeeCurrentLocation: LookupField[] = [];
  rank: LookupField[] = [];
  gender: LookupField[];
  shortTermVisa: LookupField[];
  immigrationCaseType: LookupField[] = [];
  nationalityType: LookupField[] = [];

  visaType$: Observable<LookupField[]>;
  officeLocation$: Observable<LookupField[]>;
  visaCountries$: Observable<LookupField[]>;
  form = new UntypedFormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[];
  immigrationCaseTypeOrg: LookupField[] = [];
  isEdit = false;
  activityTypes = [
    {
      id: 100,
      displayText: 'Email',
      disabled: false
    },
    {
      id: 101,
      displayText: 'Profile update',
    },
    {
      id: 102,
      displayText: 'External',
      disabled: false
    },
    {
      id: 104,
      displayText: 'Document upload',
      disabled: false
    }
  ];

  specialExpat = [
    {
      id: 1074,
      displayText: 'Yes',
      disabled: false,
      value: true
    },
    {
      id: 1075,
      displayText: 'No',
      disabled: false,
      value: false
    },
  ]

  createForm = new UntypedFormGroup({
    activityType: new UntypedFormControl(null, [Validators.required]),
    order: new UntypedFormControl(null, [Validators.required]),
    header: new UntypedFormControl(null, [Validators.required]),
    description: new UntypedFormControl(null, [Validators.required]),
    isActive: new UntypedFormControl(true, [Validators.required]),
    visaTypes: new UntypedFormControl(null, [Validators.required]),
    country: new UntypedFormControl(null, [Validators.required]),
    preboardingTypes: new UntypedFormControl(null),
    officeToBeVisited: new UntypedFormControl(null),
    currentVisaStatus: new UntypedFormControl(null),
    nationality: new UntypedFormControl(null),
    typeOfSupport: new UntypedFormControl(null),
    officeLE: new UntypedFormControl(null),
    excludedNationality: new UntypedFormControl(null),
    employeeCurrentLocation: new UntypedFormControl(null),
    gender: new UntypedFormControl(),
    shortTermVisa: new UntypedFormControl(null),
    specialExpat: new UntypedFormControl(null),
    immigrationCaseType: new UntypedFormControl(null),
    id: new UntypedFormControl(0),
    rank: new UntypedFormControl(null),
    nationalityType: new UntypedFormControl(null),
  });
  activityId: number;





  constructor(
    private configurationService: ConfigurationApi,
    private loader: LoaderService,
    public modal: NgbActiveModal,
    private toast: ToastService,
    private common: CommonService,
    private lookupApi: LookupApi,
    private router: ActivatedRoute,
    private _location: Location,
  ) {
    router.paramMap.subscribe(params => {
      this.activityId = +params.get('id');
      if (this.activityId) {
        this.isEdit = true;
      }
      this.visaCountry = params.get('visaCountry');
      this.visaType = params.get('visaType');
    });
  }

  ngOnInit() {

    this.loadSupportingData()
      .subscribe(p => {
        this.countries = p.countries.filter(i => [1048, 1047, 1052, 1049, 1050, 1051,1053,1055,13410].includes(i.id));
        this.visas = p.visas;
        this.preboardingTypes = p.preboardingTypes;
        this.gender = p.gender;
        this.immigrationCaseType = p.immigrationCaseType;
        this.currentVisaStatus = p.currentVisaStatus;
        this.nationality = p.nationality;
        this.shortTermVisa = p.shortTermVisa;
        this.typeOfSupport = p.typeOfSupport;
        this.employeeCurrentLocation = p.employeeCurrentLocation;
        this.rank = p.rank;
        this.nationalityType = p.nationalityType;
        this.immigrationCaseTypeOrg = p.immigrationCaseType;
        if (this.isEdit) {
          this.bindActivityInfo(this.activityId, () => { this.loadVisaTypes(); });
          this.createForm.get('country').disable();
          this.createForm.get('visaTypes').disable();
        }
        else {
          let country = this.visaCountry ? this.countries.filter(x => x.value == this.visaCountry) : null;
          if (country && country.length > 0) {
            this.createForm.patchValue({ country: country[0].id });
            this.onCountryChange()
          } 
        }
      });






  }
  loadSupportingData() {
    return forkJoin({
      preboardingTypes: this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.ONBOARDING_TYPES]),
      gender: this.common.prepareLookupObservable(LookupTypeKeys.GENDER, 0, 0),
      immigrationCaseType: this.common.prepareLookupObservable(LookupTypeKeys.IMMIGRATION_CASE_TYPE, 0, 0),
      countries: this.common.prepareLookupObservable(27, 0, 0),
      visas: this.common.prepareLookupObservable(LookupTypeKeys.VISA_TYPE, 0, 0),
      currentVisaStatus: this.common.prepareLookupObservable(LookupTypeKeys.CURRENT_VISA_STATUS),
      officeToBeVisited: this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION),
      nationality: this.common.prepareLookupObservable(LookupTypeKeys.NATIONALITY),
      typeOfSupport: this.common.prepareLookupObservable(LookupTypeKeys.TYPE_OF_SUPPORT),
      employeeCurrentLocation: this.common.GetOfficeLocationsAllCountries(),
      shortTermVisa: this.common.prepareLookupObservable(LookupTypeKeys.SHORT_TERM_VISA),
      officeLE: this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION),
      rank: this.common.getAllGlobalRanks(),
      nationalityType: this.common.prepareLookupObservable(LookupTypeKeys.NATIONALITY_TYPE)
    });
  }
  createActivity() {
    this.loader.show();

    const rawValues = this.createForm.getRawValue();
    const listOfActivities: ImmigrationActivity[] = [];
    const immActivities = this.getFormData(rawValues);
    listOfActivities.push(immActivities);
    this.configurationService.createImmigrationActivity(listOfActivities)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(resp => {
        if (resp.statusCode == 400) {
          this.toast.warning('Activity with same order already exist');
        }
        else {
          this.toast.success('Successfully created')
          this._location.back();
        }
      }, err => this.toast.error('Error in creating activity')
      );
  }


  bindActivityInfo(activityId: number, callBack?: () => void) {
    this.configurationService.getImmActivitiesById(activityId).subscribe(
      r => {
        if (r) {
          this.createForm.patchValue({
            country: r.countryId,
            isActive: r.isActive,
            activityType: r.activityType,
            order: r.order,
            header: r.header,
            description: r.description,
            visaTypes: r.visaTypeId,
          });
          if (r.additionalInfoObject) {
            this.createForm.patchValue({
              preboardingTypes: r.additionalInfoObject.preboardingTypeId,
              currentVisaStatus: r.additionalInfoObject.currentVisaStatusId,
              nationality: r.additionalInfoObject.nationality,
              typeOfSupport: r.additionalInfoObject.typeOfSupport,
              excludedNationality: r.additionalInfoObject.excludedNationality,
              employeeCurrentLocation: r.additionalInfoObject.employeeCurrentLocation,
              gender: r.additionalInfoObject.gender,
              shortTermVisa: r.additionalInfoObject.shortTermVisa,
              specialExpat: r.additionalInfoObject.specialExpat,
              immigrationCaseType: r.additionalInfoObject.immigrationCaseTypeId,
              officeToBeVisited: r.additionalInfoObject.officeToBeVisited,
              officeLE: r.additionalInfoObject.officeLE,
              rank: r.additionalInfoObject.ranks,
              nationalityType: r.additionalInfoObject.nationalityType
            });
          }
        }
        callBack();
      }
    );

  }

  updateActivity() {
    const rawValues = this.createForm.getRawValue();
    const immActivity = this.getFormData(rawValues)
    immActivity.id = this.activityId;
    if (immActivity.isActive && immActivity.order <= 0) {
      this.toast.warning("Order should be greater than zero for an active activity")
    }
    else if (!immActivity.isActive && immActivity.order != 0) {
      this.toast.warning("To modify the order of an activity, please set the activity to 'Active'")
    }
    else {
      this.loader.show();
      this.configurationService.amendImmigrationActivity(immActivity)
        .pipe(finalize(() => {
          this.loader.clear();
        }))
        .subscribe(resp => {
          if (resp) {
            if (resp.statusCode == 400) {
              this.toast.warning(resp.data)
            }
            else {
              this.toast.success('Activity successfully updated');
              this._location.back();
            }
          }
        }, err => {
          this.toast.error('An error occurred. Please try again.');
        }
        );
    }

  }

  getFormData(rawValues) {
    const internalAct = new ImmigrationActivity(
      {
        activityType: rawValues.activityType,
        order: rawValues.order,
        header: rawValues.header,
        description: rawValues.description,
        visaTypeId: rawValues.visaTypes,
        additionalInfoObject: this.checkIfAdditionalInfoNull(rawValues),
        isActive: rawValues.isActive
      });
    return internalAct;
  }

  loadVisaTypes() {
    const country = this.createForm.controls.country.value;
    this.lookupApi.getLookupFieldsByType(LookupTypeKeys.VISA_TYPE, 0, 0)
      .subscribe(resp => {
        this.visaTypes = resp.filter(x => x.parentFieldId === country)
        this.loadData()
        let visaId = 0;
        if(this.isEdit)
          visaId = this.createForm.getRawValue()?.visaTypes;
        else{
          let visaVal = this.visaType ? this.visas.filter(x => x.value == this.visaType) : null;
          this.createForm.patchValue({visaTypes:visaVal[0].id});
          visaId = visaVal[0].id
        }
        if(visaId){
          this.immigrationCaseType = this.immigrationCaseTypeOrg;
          this.lookupApi.getMappedLookUpFieldValues(LookupTypeKeys.IMMIGRATION_CASE_TYPE, visaId).subscribe(data => {
            this.immigrationCaseType = this.immigrationCaseType.filter(x=> data.includes(x.id));
          });
        }
      });

  }

  loadData() {
    const countryId = this.createForm.controls.country.value;
    const country = this.countries.find(x => x.id === countryId);
    if (country) {
      this.lookupApi.getOfficeLEByCountryCode(country.value)
        .subscribe(resp => {
          this.officeLE = resp;
        });
      this.lookupApi.getOfficeLocations(country.value)
        .subscribe(resp => {
          this.officeToBeVisited = resp;
        });
    }
  }


  onCountryChange() {
    this.createForm.get('visaTypes').setValue(null);
    this.resetValue();
    this.loadVisaTypes();
  }

  onVisaChange($event) {
    this.resetValue();
    this.loadData();
    this.immigrationCaseType = this.immigrationCaseTypeOrg;
    this.lookupApi.getMappedLookUpFieldValues(LookupTypeKeys.IMMIGRATION_CASE_TYPE, $event.id).subscribe(data => {
      this.immigrationCaseType = this.immigrationCaseType.filter(x=> data.includes(x.id));
    });
  }

  resetValue() {
    this.officeLE = [];
    this.officeToBeVisited = [];
    this.createForm.get('officeLE').setValue(null);
    this.createForm.get('officeToBeVisited').setValue(null);
  }

  onCancel() {
    this._location.back();
  }

  checkIfAdditionalInfoNull(rawValues) {
    const obj = new AdditionalInfo({
      immigrationCaseTypeId: rawValues.immigrationCaseType,
      preboardingTypeId: rawValues.preboardingTypes,
      officeToBeVisited: rawValues.officeToBeVisited,
      currentVisaStatusId: rawValues.currentVisaStatus,
      nationality: rawValues.nationality,
      typeOfSupport: rawValues.typeOfSupport,
      officeLE: rawValues.officeLE,
      excludedNationality: rawValues.excludedNationality,
      employeeCurrentLocation: rawValues.employeeCurrentLocation,
      gender: rawValues.gender,
      shortTermVisa: rawValues.shortTermVisa,
      specialExpat: rawValues.specialExpat,
      ranks: rawValues.rank,
      nationalityType: rawValues.nationalityType
    })
    Object.keys(obj).forEach(key => {
      if (obj[key] === null || obj[key] === undefined || nullSafe(() => obj[key].length === 0)) {
        delete obj[key];
      }
    });
    return !this.removeEmpty(obj) ? obj : null;
  }

  removeEmpty(additionalInfo) {
    return Object.values(additionalInfo).every(x => (x === null));
  }
}

